module.exports = __webpack_public_path__ + "img/slabs.5c971f16.svg";